import React from 'react';
import SignupForm from '@components/SignupForm';
import { getDefaultLayout, PageLayout } from '@layouts/Layout';
import LoginContextMessage from '@components/LoginContextMessage';
import FancyRegistration from '@components/FancyRegistration';
import SamlLoginBanner from '@components/SamlLoginBanner';
import NextLink from 'next/link';
import { Link } from '@mui/material';
import useInviteHref from '@hooks/useInviteHref';

const SignupPage: PageLayout = () => {
    const inviteHref = useInviteHref('login');

    return (
        <FancyRegistration
            form={
                <div>
                    <LoginContextMessage className="mb-8" />
                    <SamlLoginBanner className="mb-4 md:mb-8" />
                    <div className="mb-14 space-y-2">
                        <h3 className="text-center text-3xl font-semibold tracking-tight">Welcome to Pluto</h3>
                        <p className="text-center">
                            To get started, please create an account below. If you already have an account, please&nbsp;
                            <NextLink href={inviteHref} passHref legacyBehavior>
                                <Link variant="body2">login</Link>
                            </NextLink>
                            .
                        </p>
                    </div>
                    <SignupForm />
                </div>
            }
        />
    );
};

SignupPage.getLayout = getDefaultLayout({
    container: false,
    showLogo: false,
    noMargin: true,
    title: 'Create an account on Pluto',
    description: 'Pluto Bioinformatics  - Get an account and start analyzing data',
});

export default SignupPage;
